import { useCallback, useMemo } from "react";
import { useSyncExternalStore } from "use-sync-external-store/shim";
import { StateStore } from "../../state-store.js";
const noop = () => { };
export function useStateStore(store, selector) {
    const wrappedSubscription = useCallback((onStoreChange) => {
        const unsubscribe = store?.subscribeWithSelector(selector, onStoreChange);
        return unsubscribe ?? noop;
    }, [store, selector]);
    const wrappedSnapshot = useMemo(() => {
        let cachedTuple;
        return () => {
            const currentValue = store?.getLatestValue();
            if (!currentValue)
                return undefined;
            // store value hasn't changed, no need to compare individual values
            if (cachedTuple && Object.is(cachedTuple[0], currentValue)) {
                return cachedTuple[1];
            }
            const newlySelected = selector(currentValue);
            // store value changed but selected values wouldn't have to, double-check selected
            const selectionsAreEqual = StateStore.doSelectionsEqual(cachedTuple?.[1], newlySelected);
            if (selectionsAreEqual)
                return cachedTuple[1];
            cachedTuple = [currentValue, newlySelected];
            return cachedTuple[1];
        };
    }, [store, selector]);
    const state = useSyncExternalStore(wrappedSubscription, wrappedSnapshot);
    return state;
}
//# sourceMappingURL=use-state-store.js.map